import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '@roger/ui-components';

/**
 * Ghost icon link that opens a record in a new tab, so the dialog it sits
 * in keeps its unsaved edits.
 */
export const NewTabIconLink: React.FC<{ href: string; label: string }> = ({
  href,
  label,
}) => (
  <Button asChild variant='ghost' size='icon'>
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      title={label}
      aria-label={label}
    >
      <ExternalLink className='h-3.5 w-3.5' />
    </a>
  </Button>
);
